<template>
  <div class="thankyou">
    <div>
      <img :src="car_icon" alt="Car Icon" />
    </div>
    <h1>מודעה הועלתה בהצלחה!</h1>
    <p>מעולה! המודעה תפורסם באתר לאתר בקרוב.</p>
    <button type="button" class="white" @click="start()">חזרה לעמוד הרכבים שלי</button>
    <button type="button" @click="publishNew()">פרסום מודעה נוספת</button>
  </div>
</template>
<script>
import carIconPath from "@/assets/icons/car_icon.svg";
export default {
  name: "Thankyou",
  data() {
    return {
      car_icon: carIconPath,
    };
  },
  methods: {
    start() {
      this.$router.push({
				name: 'agents-area'
			});
    },
    publishNew() {
      this.$router.push({
				name: 'locate-vehicle'
			});
    },
  },
};
</script>
